import { Pipe, PipeTransform } from '@angular/core';

import { I18NextPipe } from 'angular-i18next';

import { BillingCycle } from '@hdms/shared/common-types';

@Pipe({
  name: 'billingCycleLabel',
  standalone: true
})
export class BillingCycleLabelPipe implements PipeTransform {
  constructor(private readonly i18NextPipe: I18NextPipe) {}

  transform(billingCycle: BillingCycle): string {
    return this.i18NextPipe.transform(`shared.billingCycle.${billingCycle.toLowerCase()}`);
  }
}
